import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { ExecutiveDrillDownPage } from "@/components/executive/drill-down-page";
import { Route as authenticatedRoute } from "../_authenticated";

const VALID_METRICS = ["opportunities", "closedDeals", "grossSales", "netSales"] as const;
type DrillMetric = (typeof VALID_METRICS)[number];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/executive/drill/$metric/$month",
  loader: async () => {
    const res = await fetch("/api/hubspot/pipelines/deals");
    if (!res.ok) return { pipelines: [] };
    const data = await res.json();
    return { pipelines: data.results ?? [] };
  },
  component: ExecutiveDrillDownGuard,
});

function ExecutiveDrillDownGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();
  const { pipelines } = Route.useLoaderData();
  const { metric, month } = Route.useParams();

  if ((session?.user as { role?: string } | undefined)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  const validMetric = (VALID_METRICS as readonly string[]).includes(metric)
    ? (metric as DrillMetric)
    : null;
  const validMonth = /^\d{4}-\d{2}$/.test(month) ? month : null;

  if (!validMetric || !validMonth) {
    navigate({ to: "/executive" });
    return null;
  }

  return <ExecutiveDrillDownPage metric={validMetric} month={validMonth} pipelines={pipelines} />;
}
